import React from 'react';
import * as style from './Header.module.css';
import { DataContext } from '../DataProvider';
import Reminder from '../Reminder';
import NavBar from '../NavBar';
import SearchBar from '../SearchBar';
import ReminderDialog from '../ReminderDialog';

import styled from 'styled-components';

function Header() {
  const { remindersList, reminderBeingEdited, searchTerm } =
    React.useContext(DataContext);

  return (
    <body>
      <header class='app-bar'>
        <RemindersTitle>
          Remind<SpanAccent>Me</SpanAccent>
        </RemindersTitle>
        <NavBar />
      </header>
      <main class='content'>
        <SearchBar />

        <ReminderDialog
          key={reminderBeingEdited ? reminderBeingEdited.KEY : 'new'}
        />

        <div class='table-container'>
          <table class='reminders-table'>
            <thead>
              <tr>
                <th class='col-controls'></th>
                <th class='col-date'>Date</th>
                <th class='col-text'>Reminder</th>
              </tr>
            </thead>
            <tbody>
              {remindersList.map((item, index) => {
                if (item.reminder.includes(searchTerm)) {
                  return <Reminder key={index} idx={index} />;
                }
              })}
            </tbody>
          </table>
        </div>
      </main>
    </body>
  );
}

export default Header;

const RemindersTitle = styled.span`
  font-family: 'Segoe UI', sans-serif;
  color: white;
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
`;

const SpanAccent = styled.span`
  color: #6366f1;
`;
